/* Nebula PDP: "Cannot decide?" product carousel (replaces PageFly pf-1a8f9047).
   Native scroll-snap track; this adds prev/next arrows (one product per click, hidden at the
   ends like live), one dot per scroll position, and keeps them in sync with touch/trackpad
   scrolling. No autoplay and no loop (live has neither). */
(function () {
  if (window.__npdpCarousel) return;
  window.__npdpCarousel = true;

  var instances = new WeakMap();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function state(root) {
    var track = root.querySelector('[data-npdp-carousel-track]');
    if (!track) return null;
    var slides = track.children;
    if (!slides.length) return null;
    var step = slides[0].getBoundingClientRect().width;
    if (!step) return null;
    var perView = Math.max(1, Math.round(track.clientWidth / step));
    var positions = Math.max(1, slides.length - perView + 1);
    var index = Math.min(positions - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    return { track: track, step: step, positions: positions, index: index };
  }

  function render(root) {
    var s = state(root);
    if (!s) return;
    var prev = root.querySelector('[data-npdp-carousel-prev]');
    var next = root.querySelector('[data-npdp-carousel-next]');
    var dots = root.querySelector('[data-npdp-carousel-dots]');
    if (prev) prev.hidden = s.index <= 0;
    if (next) next.hidden = s.index >= s.positions - 1;
    if (!dots) return;
    var count = s.positions > 1 ? s.positions : 0;
    if (dots.children.length !== count) {
      var html = '';
      for (var i = 0; i < count; i++) {
        html += '<button type="button" class="npdp-carousel__dot" data-npdp-carousel-dot="' + i + '" aria-label="Go to slide ' + (i + 1) + '"></button>';
      }
      dots.innerHTML = html;
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].setAttribute('aria-current', j === s.index ? 'true' : 'false');
    }
  }

  function go(root, index) {
    var s = state(root);
    if (!s) return;
    var target = Math.min(s.positions - 1, Math.max(0, index));
    s.track.scrollTo({ left: target * s.step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-npdp-carousel-track]');
    if (!track) {
      if (window.Shopify && Shopify.designMode) console.warn('[npdp-carousel] no products to show', root.id);
      return;
    }
    var ac = new AbortController();
    var frame = 0;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; render(root); });
    }, { passive: true, signal: ac.signal });
    var ro = 'ResizeObserver' in window ? new ResizeObserver(function () { render(root); }) : null;
    if (ro) ro.observe(track);
    instances.set(root, { ac: ac, ro: ro });
    render(root);
  }

  function destroy(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.ac.abort();
    if (inst.ro) inst.ro.disconnect();
    instances.delete(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-npdp-carousel]').forEach(init);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-npdp-carousel-prev], [data-npdp-carousel-next], [data-npdp-carousel-dot]');
    if (!btn) return;
    var root = btn.closest('[data-npdp-carousel]');
    if (!root) return;
    var s = state(root);
    if (!s) return;
    if (btn.hasAttribute('data-npdp-carousel-dot')) go(root, +btn.getAttribute('data-npdp-carousel-dot'));
    else go(root, s.index + (btn.hasAttribute('data-npdp-carousel-next') ? 1 : -1));
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-npdp-carousel]').forEach(destroy);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
